<template>
    <v-container fluid>
        <v-dialog
            :value="true"
            hide-overlay
            persistent
            width="80%"
            >
            <v-card
                color="primary"
                dark
            >
                <v-card-text v-if="requesting">
                    Waiting for authorization...
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
                <v-card-actions v-else-if="user && user.isAnonymous">
                    <v-text-field light solo :disabled="requesting" :value="user.displayName" @input="$set(user, 'displayName', $event)" label="name" placeholder="Enter your name" />
                </v-card-actions>
                <v-card-actions>
                    <v-btn :disabled="!user || !(user.displayName) || requesting" block outline @click="request(user)">
                       {{ $route.params.privacy === "private" ? 'Request permissions' : 'Create your pronostic' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { fromDate, firestore, auth, storage, ui, uiConfig } from "@/firebase";

export default {
  data() {
    return {
      requesting: false,
      my_request: null,
      user: null
    };
  },
  mounted() {
    console.log(this.$route.params)
    auth.onAuthStateChanged(user => {
      this.user = user;
      this.bind(user);
      if (this.$route.params.privacy !== "private") {
        this.request(user)
      }
    });
  },
  methods: {
    request(user) {
      if (user && user.uid && user.displayName) {
        this.requesting = true;
        const my_request = firestore
          .collection("babies")
          .doc(this.$route.params.id)
          .collection("requests")
          .doc(user.uid);
        const profile = {
          uid: user.uid,
          email: user.email,
          picture: user.photoURL,
          name: user.displayName,
          anonymous: user.isAnonymous
        };
        my_request.set({
          ...profile,
          authorized: this.$route.params.privacy !== "private",
          date: new Date()
        });
        firestore
          .collection("users")
          .doc(auth.currentUser.uid)
          .set(profile);
      }
    },
    bind(user) {
      const my_request = firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .collection("requests")
        .doc(user.uid);
      this.$bind("my_request", my_request);
      return my_request;
    }
  },
  watch: {
    my_request(my_request) {
      if (my_request && my_request.authorized) {
        this.requesting = false;
        this.$router.push({
          name: "dashboard-timeline",
          params: this.$route.params
        });
      } else {
        this.requesting = true;
      }
    }
  }
};
</script>
